import { FunctionComponent, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { LastDateValue } from '../../../shared';

import classNames from 'classnames';
import classes from './DateFilter.module.scss';

interface DateFilterProps {
  value: LastDateValue;
  setValue: (value: LastDateValue) => void;
}

export const DateFilter: FunctionComponent<DateFilterProps> = memo(({ value, setValue }) => {
  const { t } = useTranslation();

  const lastDateValues = [
    LastDateValue.LAST_7_DAYS,
    LastDateValue.LAST_30_DAYS,
    LastDateValue.LAST_12_MONTHS,
  ];

  return (
    <div className={classes['filter']}>
      {lastDateValues.map((lastDateValue) => {
        const isSelected = value === lastDateValue;

        return (
          <button
            key={lastDateValue}
            type={'button'}
            className={classNames(classes['filter__value'], {
              [classes['filter__value--selected']]: isSelected,
            })}
            aria-pressed={isSelected}
            onClick={() => setValue(lastDateValue)}
          >
            {t(`dateRangeFilter.${lastDateValue}`)}
          </button>
        );
      })}
    </div>
  );
});
